import React from "react";
import { motion } from "framer-motion";

const Hero = () => (
  <section className="bg-gradient-to-br from-fuchsia-600 via-purple-600 to-indigo-700 text-white py-28 px-6 text-center">
    <motion.h1
      className="text-4xl md:text-6xl font-bold mb-6"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
    >
      Welcome to <span className="text-yellow-300">Stackness</span>
    </motion.h1>
    
    <motion.p
      className="text-lg md:text-2xl mb-4 max-w-2xl mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
    >
      One dashboard. Zero clutter. Full control.
    </motion.p>

    <motion.a
      href="#contact"
      className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold px-6 py-3 rounded-xl inline-block transition mt-4"
      whileHover={{ scale: 1.05 }}
    >
      🚀 Get Early Access
    </motion.a>
  </section>
);

export default Hero;
